import { Component, OnDestroy } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FilesTypes } from '@enums/files-type.enum';
import { UploadService } from '@services/upload.service';
import { ImageTransform } from 'ngx-image-cropper';
import { Subscription } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { ToastComponent } from '../toast/toast.component';
import { DialogRef } from '@shared/services/dialog/dialog-refs.helper';
import { UserDataService } from '@shared/services/userdata.service';
import { ELocalStorage } from '@enums/localstorage.enum';
import { AdminUsersService } from '@services/admin-users.service';

@Component({
  selector: 'app-dialog-profile-img',
  templateUrl: './dialog-profile-img.component.html',
  styleUrls: ['./dialog-profile-img.component.scss'],
})
export class DialogProfileImgComponent implements OnDestroy {
   imageChangedEvent: any = '';
   croppedImage: any = '';
   transform: ImageTransform = {};
   rotation: number = 0
   canvasRotation: number = 0
   translateH = 0;
   translateV = 0;
   zoom: number = 0
   ajustImg: number = 0
   isRotating: number = 0
   imgOnly: string = FilesTypes.img_only
   savingLoading: boolean = false;
   public subscriptions: Subscription[] = [];
   constructor(private uploadService: UploadService, private snackBar: MatSnackBar, private dialogRef: DialogRef, private adminUsersService: AdminUsersService, private userDataService: UserDataService){}

   ngOnDestroy() {
      this.subscriptions.forEach(s => s.unsubscribe());
   }
   rotateLeft() {
      this.isRotating = 1
      setTimeout(() => {
         this.canvasRotation--;
         this.flipAfterRotate();
      });
   }

   rotateRight() {
      this.isRotating = 2
      setTimeout(() => {
         this.canvasRotation++;
         this.flipAfterRotate();
      });
   }
    flipHorizontal() {
      this.transform = {
        ...this.transform,
        flipH: !this.transform.flipH
      };
    }

    flipVertical() {
      this.transform = {
        ...this.transform,
        flipV: !this.transform.flipV
      };
    }

   changeZoom(ev: any) {
      const scaleSize: any = ev.value/10
      const newScale = 1 + parseFloat(scaleSize);
      this.transform = {
         ...this.transform,
         scale: newScale,
       };
   }

   resetImage(){
      this.canvasRotation = 0
      this.zoom = 0
      this.ajustImg = 0
      this.transform = {};
   }
   rotateImage(ev: any){
      this.transform = {
         ...this.transform,
         rotate: ev.value,
       };
   }

   fileChangeEvent(event: any): void {
      this.imageChangedEvent = event;
   }
   private flipAfterRotate() {
      const flippedH = this.transform.flipH;
      const flippedV = this.transform.flipV;
      this.transform = {
        ...this.transform,
        flipH: flippedV,
        flipV: flippedH
      };
      this.translateH = 0;
      this.translateV = 0;
   }

   saveImage(){
      this.savingLoading = true
      const formData = new FormData();
      formData.append('profile', this.croppedImage, 'profile_image.png');
      this.subscriptions.push(
         this.uploadService
               .uploadFiles(formData, 'image', false)
               .subscribe({
                  next: (res: string[]) => {
                     this.updateImageProfile(res[0])
                  },
                  error: error => {
                     const data: any = {
                        title: "Error",
                        text: error.error.message,
                        type: "error",
                        icon: "cancel-circle",
                     };
                     this.openToast(data);
                  },
               })
      )
   }

   openToast(data: any) {
      this.snackBar.openFromComponent(ToastComponent, {
         verticalPosition: 'bottom',
         data: data,
         horizontalPosition: 'right',
      })
   }

   updateImageProfile(imgUrl: string){
      this.adminUsersService.updateAdminProfilePhoto(imgUrl)
      .pipe(finalize(() => this.savingLoading = false))
      .subscribe({
         next: () =>{
            const userData = JSON.parse(localStorage.getItem(ELocalStorage.USER_DATA) || '')
            userData.photo = imgUrl
            this.userDataService.setStorageUserData(userData)
            this.dialogRef.close();
            const data: any = {
               title: "Success",
               text: "Foto salva com sucesso",
               type: "success",
               icon: "ok-circle",
            };
            this.openToast(data);
         },
         error: error => {
            const data: any = {
               title: "Error",
               text: 'Falha ao salvar a foto',
               type: "error",
               icon: "cancel-circle",
            };
            this.openToast(data);
         },
      })
   }
}
